<template>
  <v-list dense>
    <v-list-item @click="_changeMode()" title="Toggle Dark Mode" v-if="!$breakpoint.smAndUp">
      <v-list-item-icon>
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Toggle Dark Mode</v-list-item-title>
        <v-list-item-subtitle>Change between dark mode and light mode</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item href="/login" @click.stop.prevent="goTo('/login')" title="Login">
      <v-list-item-icon>
        <v-icon>mdi-login</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Login</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item href="/register" @click.stop.prevent="goTo('/register')" title="Register">
      <v-list-item-icon>
        <v-icon>mdi-account-plus</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Register</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item href="/dashboard" @click.stop.prevent="goTo('/dashboard')" title="Register">
      <v-list-item-icon>
        <v-icon>mdi-dashboard</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item role="button" @click.stop.prevent="goTo('/client/register')" href="/client/register" title="Client register">
      <v-list-item-icon>
        <v-icon>mdi-needle</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Register as a Patient</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item role="button" @click.stop.prevent="goTo('/professional/register')" href="/professional/register" title="Professional register">
      <v-list-item-icon>
        <v-icon>mdi-stethoscope</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Register as a Professional</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'GuestMenu'
}
</script>
